"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTag = exports.StyledTagCLose = exports.StyledTagText = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Text_1 = require("../../../../Text");
const View_1 = require("../../../../View");
const TAG_HEIGHT = '22px';
exports.StyledTagText = (0, styled_components_1.default)(Text_1.Text) `
    line-height: ${TAG_HEIGHT};

    ${({ disabled, theme }) => (0, styled_components_1.css) `
        color: ${disabled ? theme.colorTextLight : theme.colorTextMain};
    `}
`;
// TODO: Should be a button, with type=button. Size should be enough for click, and should have hover, active, focus states as well.
exports.StyledTagCLose = (0, styled_components_1.default)(Text_1.Text).attrs({
    weight: Text_1.TEXT_WEIGHT.bold
}) `
    font-size: 9px;
    cursor: pointer;
    line-height: 1;
    user-select: none;

    ${({ disabled, error, theme }) => {
    if (disabled) {
        return (0, styled_components_1.css) `
                color: ${theme.colorControlIconDisabled};
            `;
    }
    if (error) {
        return (0, styled_components_1.css) `
                color: ${theme.colorControlIconError};
            `;
    }
    return (0, styled_components_1.css) `
            color: ${theme.colorControlIcon};
        `;
}}
`;
exports.StyledTag = (0, styled_components_1.default)(View_1.View).attrs(({ disabled, error }) => ({
    spaceHorizontal: View_1.INDENT.s,
    align: View_1.VIEW_ALIGN.center,
    distribution: View_1.VIEW_DISTRIBUTION.fill,
    backgroundView: disabled
        ? View_1.VIEW_BG_VIEW.disabled
        : error
            ? View_1.VIEW_BG_VIEW.highlightError
            : View_1.VIEW_BG_VIEW.highlight
})) `
    max-width: 100%;
    height: ${TAG_HEIGHT};
`;
//# sourceMappingURL=Tag.styles.js.map